import React, { useEffect, useRef, useState } from 'react';

import './style.scss'
import { SEOHeader } from 'views/components';
import { RadioButton, SelectField } from 'views/components/form-inputs';
import CustomToast from 'views/components/form-inputs/alert';
import { Message } from 'primereact/message';
import { InputTextarea } from 'primereact/inputtextarea';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button } from 'primereact/button';
import { showTostify } from 'utils/interfaces';
import { useNavigate, useParams } from 'react-router-dom';
import { routes } from 'utils/routes';
import { storeService } from 'services/store.service';
import { Rating } from 'primereact/rating';

const initialValue = {
  store_id: "",
  status: "active",
  rating: "",
  review: "",
};

const AddReviews = () => {
  const toastRef = useRef<any>(null);
  const navigation = useNavigate()
  const params = useParams()
  const id: any = params.id
  const [loading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState(initialValue);
  const [stores, setStores] = useState([]);

  const formik: any = useFormik({
    initialValues: initialData,
    enableReinitialize: true,
    validationSchema: Yup.object({

      store_id: Yup.string().required('Store is required'),
      status: Yup.string().required('Status is required'),
      rating: Yup.string().required('rating is required'),
      review: Yup.string().required('Message is required'),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        if (id) {
          delete values.id
          delete values.created_by
          delete values.created_at
          delete values.updated_at
          const data = await storeService.updateReviewStore(id, values);
          if (data.error === false) {
            showTostify(toastRef, 'success', data.message);
            setTimeout(() => {
              navigation(`${routes.review}`);
            }, 800)
          }
          else {
            showTostify(toastRef, 'error', data.message);
          }
        }
        else {
          const data = await storeService.createReviewStore(values);
          if (data.error === false) {
            showTostify(toastRef, 'success', data.message);
            setTimeout(() => {
              navigation(`${routes.review}`);
            }, 800)
          }
          else {
            showTostify(toastRef, 'error', data.message);
          }
        }
      } catch (err: any) {
        showTostify(toastRef, 'error', err.message);
      } finally {
        setLoading(false);
      }
    }
  });

  useEffect(() => {
    if (id) {
      setLoading(true)
      const getStoresReviewDetails = async () => {
        const data = await storeService.getStoresReviewDetails(id);
        if (!data.error) {
          setInitialData(data)
          setLoading(false);
        } else {
          showTostify(toastRef, 'error', data.message);
          setLoading(false);
        }
      };
      getStoresReviewDetails();
    }

    const fetchStores = async () => {
      const response = await storeService.getStoresReport();
      if (!response.error) {
        setStores(response.items || []);
      } else {
        showTostify(toastRef, 'error', response.message);
      }
    };

    fetchStores();
  }, [id]);
  console.log(formik.errors);

  return (
    <>
      <CustomToast ref={toastRef} />
      <SEOHeader title="Create Review & Rating" />

      <div className="quicklinks-page">
        <div className="container">
          <div className='bg-white border-round-2xl w-75'>
            <form onSubmit={formik.handleSubmit} >
              <div className="p-4 border-bottom-1 border-primary-color">
                <h2 className='text-start m-0'>{id ? "Edit Review & Rating" : "Add New Review & Rating"}</h2>
              </div>
              <div className="grid m-0 py-4 p-3">
                <div className="grid m-0">
                  <div className="col-12 md:col-6 lg:col-4">
                    <SelectField
                      name="store_id"
                      label="Store"
                      filter
                      showClear
                      value={formik.values.store_id || ""}
                      onChange={(e) => formik.setFieldValue('store_id', e.value)}
                      options={stores.map((store: any) => ({ label: store.title, value: store.id }))}
                      error={formik.touched.store_id && formik.errors.store_id}
                      required={true}
                      className="my-custom-class"
                    />
                  </div>
                  <div className="col-12 md:col-6 lg:col-4 ">
                    {/* <SelectField
                      name="rating"
                      label="Rating"
                      value={formik.values.rating}
                      onChange={(e) => formik.setFieldValue('rating', e.value)}
                      options={Array.from({ length: 5 }, (_, i) => ({
                        label: `${i + 1}`,
                        value: `${i + 1}`,
                      }))}
                      error={formik.touched.state && formik.errors.state}
                      required={true}
                      className="my-custom-class"
                    /> */}
                    <div className={`form-group mb-2  `}>
                      <label className="form-label">
                        Rating <span className="required-field">*</span>
                      </label>

                      <Rating
                        value={formik.values.rating}
                        onChange={(e) => formik.setFieldValue('rating', e.value)}
                        onBlur={() => {
                          console.log('Rating lost focus');
                          formik.handleBlur({ target: { name: 'rating' } }); // Manually trigger formik blur
                        }}
                        cancel={false}
                        className="custom-rating"
                      />
                    </div>
                  </div>
                  <div className="col-12 md:col-6 lg:col-4">
                    <div>
                      <RadioButton
                        className="custom-form-check"
                        name="status"
                        value={formik.values.status}
                        onChange={(e: any) => formik.setFieldValue('status', e.value)}
                        options={[
                          { label: 'Published', value: 'published', },
                          { label: 'Hidden', value: 'hidden', },
                        ]}
                        required={true}
                        label="Status"
                        error={formik.touched.status && formik.errors.status}
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group mb-2">
                      <label htmlFor="review">Review <span className="required-field">*</span></label>
                      <InputTextarea
                        placeholder="Enter here"
                        rows={3}
                        className='w-full'
                        name="review"
                        value={formik.values.review}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik?.touched.review && formik.errors.review && <Message severity="error" text={formik.errors.review} />}
                    </div>
                  </div>

                  <div className="col-12 text-center">
                    <Button
                      label={id ? "Edit Review & Rating" : "Add Review & Rating"}
                      type="submit"
                      className="primary"
                      loading={loading}
                      disabled={loading}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddReviews;

